<div class="kpi-section">

  <!-- ── Imports row (4 cards with sparklines) ──────────────── -->
  <div class="kpi-row imports-row">

    <!-- Total Imports -->
    <div class="kpi-card kpi-card-large clickable" [class.loading]="isLoading" role="button" tabindex="0" (click)="openImports()" (keydown.enter)="openImports()" (keydown.space)="$event.preventDefault(); openImports()">
      <div class="card-head">
        <span class="kpi-label">TOTAL IMPORTS</span>
        <div class="icon-badge purple-badge"><span class="sigma">∑</span></div>
      </div>
      <div class="value-row">
        <div class="big-value white">{{ totalImports | number }}</div>
        <span class="delta-pill" [class]="deltaPolarity(totalImportsDelta)">{{ formatDelta(totalImportsDelta) }}</span>
      </div>
    </div>

    <!-- Successful -->
    <div class="kpi-card kpi-card-large clickable" [class.loading]="isLoading" (click)="openSuccessful()">
      <div class="card-head">
        <span class="kpi-label">SUCCESSFUL</span>
        <div class="icon-badge green-badge"><span class="check">✓</span></div>
      </div>
      <div class="value-row">
        <div class="value-block">
          <div class="big-value white">{{ importsSuccessful | number }}</div>
          <div class="value-sub">{{ successRate }}% success rate</div>
        </div>
        <span class="delta-pill" [class]="deltaPolarity(successfulDelta)">{{ formatDelta(successfulDelta) }}</span>
      </div>
    </div>

    <!-- Partial -->
    <div class="kpi-card kpi-card-large clickable" [class.loading]="isLoading" (click)="openPartial()">
      <div class="card-head">
        <span class="kpi-label">PARTIAL</span>
        <div class="icon-badge amber-badge"><span class="excl">!</span></div>
      </div>
      <div class="value-row">
        <div class="value-block">
          <div class="big-value white">{{ importsPartial | number }}</div>
          <div class="value-sub">{{ partialRate }}% of total</div>
        </div>
        <span class="delta-pill" [class]="deltaPolarity(partialDelta, true)">{{ formatDelta(partialDelta) }}</span>
      </div>
    </div>

    <!-- Failed -->
    <div class="kpi-card kpi-card-large clickable" [class.loading]="isLoading" (click)="openFailed()">
      <div class="card-head">
        <span class="kpi-label">FAILED</span>
        <div class="icon-badge red-badge"><span class="cross">×</span></div>
      </div>
      <div class="value-row">
        <div class="value-block">
          <div class="big-value white">{{ importsFailed | number }}</div>
          <div class="value-sub">{{ failedRate }}% of total</div>
        </div>
        <span class="delta-pill" [class]="deltaPolarity(failedDelta, true)">{{ formatDelta(failedDelta) }}</span>
      </div>
    </div>
  </div>

  <!-- ── Pure Originals & Masters row (5 small cards) ───────── -->
  <div class="kpi-row po-row">

    <!-- Pure Originals -->
    <div class="kpi-card kpi-card-small clickable" [class.loading]="isLoading" role="button" tabindex="0" (click)="openPureOriginals()" (keydown.enter)="openPureOriginals()" (keydown.space)="$event.preventDefault(); openPureOriginals()">
      <div class="card-head">
        <span class="kpi-label-sm">PURE ORIGINALS</span>
        <div class="icon-badge-sm purple-badge"><i class="bi bi-file-earmark"></i></div>
      </div>
      <div class="value-row">
        <div class="small-value white">{{ totalPureOriginal | number }}</div>
        <span class="delta-pill-sm" [class]="deltaPolarity(poDelta)">{{ formatDelta(poDelta) }}</span>
      </div>
      <div class="value-sub-sm">vs prev period</div>
    </div>

    <!-- Missing Match -->
    <div class="kpi-card kpi-card-small" [class.loading]="isLoading" [class.clickable]="canOpenMatches('missing')"
         role="button" [attr.tabindex]="canOpenMatches('missing') ? 0 : -1" [attr.aria-disabled]="!canOpenMatches('missing')"
         (click)="openMatches('missing')" (keydown.enter)="openMatches('missing')" (keydown.space)="$event.preventDefault(); openMatches('missing')">
      <div class="card-head">
        <span class="kpi-label-sm">MISSING MATCH</span>
        <div class="icon-badge-sm red-badge"><i class="bi bi-exclamation-triangle"></i></div>
      </div>
      <div class="value-row">
        <div class="small-value red">{{ poMissing | number }}</div>
        <span class="delta-pill-sm" [class]="deltaPolarity(poMissingDelta, true)">{{ formatDelta(poMissingDelta) }}</span>
      </div>
      <div class="value-sub-sm">no matching found</div>
    </div>

    <!-- Partial Match -->
    <div class="kpi-card kpi-card-small" [class.loading]="isLoading" [class.clickable]="canOpenMatches('partial')"
         role="button" [attr.tabindex]="canOpenMatches('partial') ? 0 : -1" [attr.aria-disabled]="!canOpenMatches('partial')"
         (click)="openMatches('partial')" (keydown.enter)="openMatches('partial')" (keydown.space)="$event.preventDefault(); openMatches('partial')">
      <div class="card-head">
        <span class="kpi-label-sm">PARTIAL MATCH</span>
        <div class="icon-badge-sm amber-badge"><i class="bi bi-clock-history"></i></div>
      </div>
      <div class="value-row">
        <div class="small-value amber">{{ poPartial | number }}</div>
        <span class="delta-pill-sm" [class]="deltaPolarity(poPartialDelta, true)">{{ formatDelta(poPartialDelta) }}</span>
      </div>
      <div class="value-sub-sm">partially matched</div>
    </div>

    <!-- Successful Match -->
    <div class="kpi-card kpi-card-small" [class.loading]="isLoading" [class.clickable]="canOpenMatches('successful')"
         role="button" [attr.tabindex]="canOpenMatches('successful') ? 0 : -1" [attr.aria-disabled]="!canOpenMatches('successful')"
         (click)="openMatches('successful')" (keydown.enter)="openMatches('successful')" (keydown.space)="$event.preventDefault(); openMatches('successful')">
      <div class="card-head">
        <span class="kpi-label-sm">SUCCESSFUL MATCH</span>
        <div class="icon-badge-sm green-badge"><i class="bi bi-check2"></i></div>
      </div>
      <div class="value-row">
        <div class="small-value green">{{ poSuccessful | number }}</div>
        <span class="delta-pill-sm" [class]="deltaPolarity(poSuccessfulDelta)">{{ formatDelta(poSuccessfulDelta) }}</span>
      </div>
      <div class="value-sub-sm">fully matched</div>
    </div>

    <!-- Masters -->
    <div class="kpi-card kpi-card-small clickable" [class.loading]="isLoading" role="button" tabindex="0" (click)="openMasterDatabase()" (keydown.enter)="openMasterDatabase()" (keydown.space)="$event.preventDefault(); openMasterDatabase()">
      <div class="card-head">
        <span class="kpi-label-sm">MASTERS</span>
        <div class="icon-badge-sm purple-badge"><i class="bi bi-files"></i></div>
      </div>
      <div class="value-row">
        <div class="small-value white">{{ totalMaster | number }}</div>
        <span class="delta-pill-sm" [class]="deltaPolarity(masterDelta)">{{ formatDelta(masterDelta) }}</span>
      </div>
      <div class="value-sub-sm">total master files</div>
    </div>
  </div>

  <!-- Loading overlay -->
  <div class="kpi-loading-overlay" *ngIf="isLoading && !overview">
    <div class="spinner"></div>
  </div>
</div>
